import PaymentDetailsPage from './PaymentDetailsPage';

export default PaymentDetailsPage;
